module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/deI7ys/tc-custom/9781426813115.jpg?1704857464660",
      "alt": "This image is the cover for the book Tycoon's Virgin"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tycoon's Virgin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Caz Ryan grew up with nothing. So shereinvented herself: and became a success—butonly in business, never with men.…When she heads to the country in search ofher inheritance she's in for a shock—she's not anoutdoors girl. Until she's rescued by tall, ruggedGalem Brent. Suddenly the country holdsa lot more appeal!Caz knows Galem's going to seduce her. And she'llallow herself one weekend. But when Mondaycomes does she want to be the city girl she'sstrived to become…or the real Caz Ryan?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Susan Stephens\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Susan Stephens is passionate about writing books set in fabulous locations where an outstanding man comes to grips with a cool, feisty woman. Susan’s hobbies include travel, reading, theatre, long walks, playing the piano, and she loves hearing from readers at her website. "), _c('a', {
    attrs: {
      "href": "http://www.susanstephens.com"
    }
  }, [_vm._v("www.susanstephens.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0